export default function JSONVEditSupport() {
  return (
    <main className="min-h-screen bg-[#FBFAF6] text-[#26313B]">
      <section className="mx-auto max-w-3xl px-6 py-12">
        <header className="mb-8 text-center">
          <h1 className="text-4xl font-extrabold tracking-tight text-[#A8720E]">
            Support - JSON Viewer &amp; Editor
          </h1>
          <p className="mt-2 text-sm text-[#5B6B7C]">
            Help, troubleshooting, and contact details for JSON Viewer &amp;
            Editor.
          </p>
          <p className="mt-1 text-xs text-[#8A93A2]">
            Published by <span className="font-semibold">Cosmovex</span>
          </p>
        </header>

        <div className="space-y-8 leading-relaxed text-[#3D4B59]">
          <h2 className="text-2xl font-bold text-[#A8720E]">
            Frequently Asked Questions
          </h2>

          <div className="space-y-6">
            <div>
              <h3 className="text-lg font-semibold text-[#26313B]">
                How do I open JSON in the app?
              </h3>
              <p className="mt-1">
                You can paste JSON from the clipboard, open a JSON file from
                device storage, use a built-in template, or start a new document
                with the Edit JSON button.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-[#26313B]">
                Can I edit invalid JSON?
              </h3>
              <p className="mt-1">
                Yes. The editor lets you correct malformed JSON and validate it
                before applying changes.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-[#26313B]">
                Does the app work offline?
              </h3>
              <p className="mt-1">
                Core viewing and editing features work offline. Internet access
                is only required for services such as ads, analytics, or store
                links.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-[#26313B]">
                Can I share or export the JSON?
              </h3>
              <p className="mt-1">
                Yes. You can copy, share, pretty-print, minify, and convert
                supported JSON structures into formats like YAML, CSV, and
                key-value text.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-[#26313B]">
                Why am I seeing ads?
              </h3>
              <p className="mt-1">
                Some versions of the app show ads to support ongoing
                development, maintenance, and feature updates.
              </p>
            </div>
          </div>

          <h2 className="text-2xl font-bold text-[#A8720E]">Contact Support</h2>
          <p>
            If you need help, have feedback, or want to report an issue, email{" "}
            <a
              href="mailto:trionapps@gmail.com"
              className="text-[#0F6BBF] underline"
            >
              trionapps@gmail.com
            </a>
            . We typically respond within 24-48 hours.
          </p>

          <h2 className="text-2xl font-bold text-[#A8720E]">Report a Bug</h2>
          <p>
            To help us resolve issues faster, include the following in your
            message when possible:
          </p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Your device model and OS version</li>
            <li>The app version shown in Settings</li>
            <li>A short description of the issue</li>
            <li>Steps to reproduce the problem</li>
          </ul>

          <h2 className="text-2xl font-bold text-[#A8720E]">App Information</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>
              <strong>App Name:</strong> JSON Viewer &amp; Editor
            </li>
            <li>
              <strong>Developer:</strong> Cosmovex
            </li>
            <li>
              <strong>Contact Email:</strong>{" "}
              <a
                href="mailto:trionapps@gmail.com"
                className="text-[#0F6BBF] underline"
              >
                trionapps@gmail.com
              </a>
            </li>
            <li>
              <strong>Privacy Policy:</strong>{" "}
              <a
                href="https://cosmovexapps.com/apps/jsonvedit/privacy-policy"
                className="text-[#0F6BBF] underline"
              >
                https://cosmovexapps.com/apps/jsonvedit/privacy-policy
              </a>
            </li>
            <li>
              <strong>Support URL:</strong>{" "}
              <a
                href="https://cosmovexapps.com/apps/jsonvedit/support"
                className="text-[#0F6BBF] underline"
              >
                https://cosmovexapps.com/apps/jsonvedit/support
              </a>
            </li>
          </ul>
        </div>

        <footer className="mt-12 border-t border-[#E1DCCE] pt-4 text-center text-sm text-[#8A93A2]">
          © {new Date().getFullYear()} Cosmovex - All rights reserved.
        </footer>
      </section>
    </main>
  );
}
